<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Cost</span></h5>
            <h3 class="my-3">
              <span>{{ totalCost | currency }}</span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-info">Total Biaya Produksi</span></h5>
            <h3 class="my-3">
              <span>{{ totalBiayaProduksi | currency }}</span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>On Hand</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addOnHand">
                      <i class="fa fa-plus" aria-hidden="true"></i> New
                    </button>
                    <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                    <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                      <i class="fa fa-filter" aria-hidden="true"></i>
                        Filter
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu p-2" >
                      <span>Category:</span>
                      <li>
                        <a href="javascript:void(0)" class="small" tabIndex="-1">
                          <input type="checkbox" value="in" v-model="filterType" /> In
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)" class="small" tabIndex="-1">
                          <input type="checkbox" value="out" v-model="filterType" /> Out
                        </a>
                      </li>
                      <div class="dropdown-divider"></div>
                      <span>Etc:</span>
                      <li>
                        <a href="javascript:void(0)" class="small" tabindex="-1">
                          <input type="checkbox" value="true" v-model="filterDiffJournal"/> Diff Biaya Produksi
                        </a>
                      </li>
                    </ul>
                    <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>&nbsp;&nbsp;
                  <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="12" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id" @click="editOnHand(u.id)" style="cursor: pointer">
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td>
                            <span v-if="u.type === 'in'" class="badge badge-success">{{ u.type }}</span>
                            <span v-else-if="u.type === 'begin'" class="badge badge-info">{{ u.type }}</span>
                            <span v-else class="badge badge-danger">{{ u.type }}</span>
                        </td>
                        <td>
                            <span v-if="u.status === 'finish'" class="badge badge-success">{{ u.status }}</span>
                            <span v-else-if="u.status === 'open'" class="badge badge-success">{{ u.status }}</span>
                            <span v-else class="badge badge-primary">{{ u.status }}</span>
                        </td>
                        <td>{{ u.hand_no }}</td>
                        <td>{{ u.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.name }}</td>
                        <td class="text-center">{{ u.in_count }}</td>
                        <td class="text-center">{{ u.out_count }}</td>
                        <td class="text-right">{{ parseFloat(u.total_cost) / parseFloat(u.qty) | currency }}</td>
                        <td class="text-right">{{ u.total_cost | currency }}</td>
                        <td class="text-center">
                          <span v-if="u.journal_count > 0"><i class="fa fa-check" style="color: green"></i></span>
                        </td>
                        <td class="text-right">
                          <span class="badge badge-danger" v-if="u.total_cost !== u.total_biaya_produksi">{{ u.total_biaya_produksi | currency }}</span>
                          <span v-else>{{ u.total_biaya_produksi | currency }}</span>
                      </td>
                      </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
      <!-- <pre>{{ dataRaw }}</pre> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { getHeader, inventoryUrl } from '../../config'

export default {
  name: 'InventoryOnHandList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startDate: [date1, date2],
      filterType: [],
      filterDiffJournal: false,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Hand No.',
        prop: 'hand_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'hand_date',
        align: 'text-left'
      }, {
        name: 'Name',
        prop: 'name',
        align: 'text-left'
      }, {
        name: 'In',
        prop: 'in_count',
        align: 'text-center'
      }, {
        name: 'Out',
        prop: 'out_count',
        align: 'text-center'
      }, {
        name: 'Cost',
        prop: 'cost',
        align: 'text-right'
      }, {
        name: 'Total Cost',
        prop: 'total_cost',
        align: 'text-right'
      }, {
        name: 'Journal',
        prop: 'journal_count',
        align: 'text-center'
      }, {
        name: 'Biaya Produksi',
        prop: 'total_biaya_produksi',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable
    }),
    totalCost () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cost)
      }
      return sum
    },
    totalBiayaProduksi () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_biaya_produksi)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterDiffJournal === true) {
          if (d.total_cost !== d.total_biaya_produksi) {
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (d.type === this.filterType[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editOnHand (id) {
      axios.get(inventoryUrl + '/on-hand/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editOnHand', response.data.data)
        })
        .catch(response => {
          this.$swal(
            'Error!!!',
            response,
            'error'
          )
        })
    },
    addOnHand () {
      this.$emit('newOnHand', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = inventoryUrl + '/on-hand?begin=' + begin + '&end=' + end
      console.log(url)
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  }
}
</script>
